/**
 * @module contactForm
 */
import {Button} from '../modules/button.js';
import {defineCustomElement} from '../utils/defineCustomElement.js';
import {t} from '../localization/translate.js';

class ContactForm extends HTMLElement {
    constructor() {
        super();
        // Bind to this instance of the component
        this.handleAfterSwap = this.handleAfterSwap.bind(this);
        this.handleBeforeRequest = this.handleBeforeRequest.bind(this);
    }

    /** Called each time the element is added to the document. */
    connectedCallback() {
        const contactForm = this.querySelector('.js-contactForm');
        contactForm.addEventListener('htmx:afterSwap', this.handleAfterSwap);
        contactForm.addEventListener('htmx:beforeRequest', this.handleBeforeRequest);
    }

    /** Called each time the element is removed from the document. */
    disconnectedCallback() {
        const contactForm = this.querySelector('.js-contactForm');
        contactForm.removeEventListener('htmx:afterSwap', this.handleAfterSwap);
        contactForm.removeEventListener('htmx:beforeRequest', this.handleBeforeRequest);
    }

    handleAfterSwap() {
        document.dispatchEvent(new CustomEvent('lazy:initContent'));

        // Re-render Turnstile after DOM changes
        if (window.turnstile) {
            const turnstileElement = this.querySelector('.cf-turnstile');
            if (turnstileElement) {
                window.turnstile.render(turnstileElement);
            }
        }
    }

    /**
     * @param {CustomEvent} event - htmx:beforeRequest event
     */
    handleBeforeRequest(event) {
        const form = this.querySelector('.js-contactForm');

        // Validate form before HTMX submits (native HTML5 validation)
        if (!form.checkValidity()) {
            event.preventDefault();
            form.reportValidity();
            return;
        }

        const submitButton = this.querySelector('button[type=submit]');
        if (submitButton) {
            Button.addLoading(submitButton, t('Submitting...'));
        }
    }
}

defineCustomElement('ixdf-contact-form', ContactForm);
